import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import FirstAdminRegisterForm from './firstAdminRegisterForm';
import SharedLoginForm from './sharedLoginForm';
import TenantLoginFormContainer from './tenantLoginForm';
import UserLoginFormContainer from './userLoginForm';
const queryString = require('query-string');
import LoginOptions from './loginOptions/loginOptions';


@inject('usersStore', 'firstAdminRegisterationStore', 'oidcStore', 'configurationsStore') @observer
class LoginContainer extends Component {

    constructor(props) {

        super(props);

        this.state = {
            firstAdminExistence: false
        };

        const { '/login?ReturnUrl': returnUrl } = queryString.parse(window.location.hash);
        const { '/login?AutoRedirect': doNotMacAutoRediret } = queryString.parse(window.location.hash);

        //Required to set Return URL automatically
        if (doNotMacAutoRediret !== undefined) {
            window.localStorage.setItem('AutoRedirect', doNotMacAutoRediret);
            window.location.hash = '';
        }

        this.returnUrl = this.sanitizeUrl(returnUrl);
    }

    sanitizeUrl(url) {
        const regex = /[<>[\](){}]/g;
        return regex.test(url) ? '' : url;
    }

    componentWillMount() {
        this.getFirstAdminExistence();
        this.props.oidcStore.getAuthorizationEndpoint();
    }

    componentDidMount() {
        this.props.configurationsStore.updateStore();
    }

    getFirstAdminExistence = () => {

        this.props.firstAdminRegisterationStore.firstAdminExistence();
    }

    isCorrectReturnUrl() {

        if (this.props.oidcStore.authorizationEndpoint
            && this.returnUrl
            && this.getAbsoluteReternUrl(this.returnUrl).startsWith(this.props.oidcStore.authorizationEndpoint)
        ) {
            return true;
        }

        return false;
    }

    getAbsoluteReternUrl(returnUrl) {

        if (process.env.NODE_ENV === 'production') {

            returnUrl = window.location.origin + returnUrl;
        }

        return returnUrl;
    }

    isLoginForAccessControl() {

        let decodedReturnUrl = decodeURIComponent(this.returnUrl);
        return decodedReturnUrl.includes(this.props.oidcStore.oidcConfig.redirect_uri);
    }

    createLoginContainer() {
        const { isMultitenancyMode } = this.props.configurationsStore;

        if (!this.props.firstAdminRegisterationStore.isFirstAdminExistence.firstAdminExists) {
            return <FirstAdminRegisterForm onFirstAdminRegistered={this.getFirstAdminExistence} />;
        }

        return <LoginOptions returnUrl={this.returnUrl} />;
    }

    render() {

        const { isMultitenancyMode } = this.props.configurationsStore;
        if (this.props.oidcStore.currentUser != undefined && this.isLoginForAccessControl()) {
            return <Redirect to='/' />;
        }

        if (this.props.firstAdminRegisterationStore.isFirstAdminExistence == null ||
            !this.isCorrectReturnUrl()
            || isMultitenancyMode === null) {
            return null;
        }

        return <SharedLoginForm component={this.createLoginContainer()} />;
    }
}

export default LoginContainer;


// WEBPACK FOOTER //
// ./src/components/account/loginContainer.jsx